import Box from '@mui/material/Box'
import { Outlet } from 'react-router-dom'

export default function ApiReference() {
  return (
    <Box sx={{ height: 'calc(100vh - 64px)', overflow: 'auto', bgcolor: 'white' }}>
      <Outlet />
    </Box>
  )
}
